import React from 'react';
import PostButton from './PostButton';
import GetButton from './GetButton';
import { FinanceCheckoutPopoverButton } from './FinanceCheckoutPopoverButton';
import NewLayerButton from './NewLayerButton';
import { TextButton } from '@oneaudi/unified-web-components';
import { PhoneButton } from './PhoneButton';
import { dynamicStylingHelper } from '../../../../utils/AlphaHelper';
export const GenericButton = ({ vehicle, appContext, buttonInfo, variant, phoneWithNumber, configurationService, layerManager, scContextId, trackButtonClick, showAsText, isMobileScreenSize, isLoading, }) => {
    const { label, url, target } = buttonInfo;
    if (buttonInfo.type === 'phone' || buttonInfo.type === 'central-customer-hotline') {
        return (React.createElement(PhoneButton, { buttonInfo: buttonInfo, variant: variant, trackButtonClick: trackButtonClick, appContext: appContext, phoneWithNumber: phoneWithNumber, isMobileScreenSize: isMobileScreenSize, isLoading: isLoading }));
    }
    if (buttonInfo.type === 'finance-checkout') {
        return (React.createElement(FinanceCheckoutPopoverButton, { buttonInfo: buttonInfo, vehicle: vehicle, variant: variant, trackButtonClick: trackButtonClick, scContextId: scContextId, isMobileScreenSize: isMobileScreenSize, isLoading: isLoading }));
    }
    if (buttonInfo.target === 'same-window' || buttonInfo.target === 'new-window') {
        if (buttonInfo.method === 'POST') {
            return (React.createElement(PostButton, { buttonInfo: buttonInfo, variant: variant, vehicle: vehicle, trackButtonClick: trackButtonClick, isMobileScreenSize: isMobileScreenSize, isLoading: isLoading }));
        }
        if (buttonInfo.method === 'GET') {
            return (React.createElement(GetButton, { buttonInfo: buttonInfo, variant: variant, trackButtonClick: trackButtonClick, isMobileScreenSize: isMobileScreenSize, isLoading: isLoading }));
        }
    }
    if (buttonInfo.target === 'open-in-layer') {
        return (React.createElement(NewLayerButton, { buttonInfo: buttonInfo, variant: variant, layerManager: layerManager, configurationService: configurationService, trackButtonClick: trackButtonClick, vehicle: vehicle, isMobileScreenSize: isMobileScreenSize, isLoading: isLoading }));
    }
    return (React.createElement(TextButton, { variant: variant, isFullWidth: isMobileScreenSize, isLoading: isLoading, href: url, target: target, onClick: () => {
            trackButtonClick(buttonInfo, showAsText ? 'text' : variant, buttonInfo.trackingCode);
        }, size: dynamicStylingHelper('md', 'sm') }, label));
};
